import { styled } from '@mui/material';


export const PurchaseCard = styled('a')`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  /* Match the CourseCard shell so the tile lines up in the slider: the
     visible box is 254px with a 10px bottom gutter (264px total). */
  min-width: 100%;
  min-height: calc(100% - 10px);
  margin-bottom: 10px;
  box-sizing: border-box;
  padding: 30px 16px;
  border: 2px dashed ${({ theme }) => theme.palette.ternary.mediumGray};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;
  background: ${({ theme }) => theme.palette.ternary.white};
  color: ${({ theme }) => theme.palette.text.primary};
  cursor: pointer;
  text-decoration: none;
  transition: background 0.2s ease;

  &:hover,
  &:focus-visible {
    /* tint-1 background on hover */
    background: ${({ theme }) => theme.palette.ternary.light};
    text-decoration: none;
  }

  &:hover .purchase-icon,
  &:focus-visible .purchase-icon {
    /* primary hover on the plus button */
    background: ${({ theme }) => theme.palette.primary.dark};
  }

  &:focus-visible {
    outline: 3px solid ${({ theme }) => theme.palette.ternary.focusBlue};
    outline-offset: -3px;
  }

  .purchase-title {
    margin-top: 4px;
  }

  .purchase-subtitle {
    margin-top: 6px;
    color: ${({ theme }) => theme.palette.ternary.dark};
  }
`;

/** Maroon rounded "pill" button holding the plus icon. */
export const PlusButton = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 40px;
  margin-bottom: 16px;
  border-radius: 20px;
  /* primary fill */
  background: ${({ theme }) => theme.palette.primary.main};
  color: ${({ theme }) => theme.palette.primary.contrastText};
  transition: background 0.2s ease;

  svg {
    font-size: 24px;
  }
`;
